import { render, staticRenderFns } from "./CategoryDemandDetails.vue?vue&type=template&id=7f6547d6&scoped=true"
import script from "./CategoryDemandDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDemandDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6547d6",
  null
  
)

export default component.exports